const MediaRelationsScreen = () => {
  
    return (
       <p>Media Relations Screen here</p>
    )
}

export default MediaRelationsScreen